import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  query,
  orderBy,
  where,
  startAt,
  endAt,
  limit,
} from "firebase/firestore";
import "../styles/History.css";
import { useNavigate } from "react-router-dom";

function History() {
  const [reviews, setReviews] = useState([]);
  const [filter, setFilter] = useState("monthly"); // default filter
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchOlderReviews() {
      const now = new Date();

      // Calculate start date based on filter
      let startDate;
      if (filter === "weekly") {
        startDate = new Date(now);
        startDate.setDate(now.getDate() - 7);
      } else if (filter === "monthly") {
        startDate = new Date(now);
        startDate.setMonth(now.getMonth() - 1);
      } else if (filter === "yearly") {
        startDate = new Date(now);
        startDate.setFullYear(now.getFullYear() - 1);
      }

      // Firestore timestamp expects a Timestamp object, so convert Date to Firestore Timestamp
      // But Firestore can compare Date objects directly as well.

      // We want to fetch reviews **older than the 10 latest**, so we fetch reviews with createdAt <= startDate
      // Actually, we want reviews createdAt between startDate and now

      // We'll query reviews created between startDate and now
      const reviewsRef = collection(db, "reviews");

      const q = query(
        reviewsRef,
        orderBy("createdAt", "desc"),
        where("createdAt", ">=", startDate),
        where("createdAt", "<=", now),
        // optionally limit to 100 or something
        limit(100)
      );

      const querySnapshot = await getDocs(q);
      const reviewList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setReviews(reviewList);
    }
    fetchOlderReviews();
  }, [filter]);

  // Group reviews same way
  const groupedData = reviews.reduce((acc, review) => {
    const hotel = review.hotelName || "Unknown Hotel";
    const email = review.userEmail || "Unknown Email";

    if (!acc[hotel]) acc[hotel] = {};
    if (!acc[hotel][email]) acc[hotel][email] = [];

    acc[hotel][email].push(review);
    return acc;
  }, {});

  return (
    <div className="history-container">

       <button className="home-button" onClick={() => navigate("/admin")}>
            Back
       </button>

      <h2>Review History</h2>

      <div className="filter-buttons">
        <button
          className={filter === "weekly" ? "active" : ""}
          onClick={() => setFilter("weekly")}
        >
          Weekly
        </button>
        <button
          className={filter === "monthly" ? "active" : ""}
          onClick={() => setFilter("monthly")}
        >
          Monthly
        </button>
        <button
          className={filter === "yearly" ? "active" : ""}
          onClick={() => setFilter("yearly")}
        >
          Yearly
        </button>
      </div>

      {Object.keys(groupedData).length === 0 && <p>No reviews found.</p>}

      {Object.keys(groupedData).map((hotel) => (
        <div key={hotel} className="hotel-section">
          <h3>{hotel}</h3>
          {Object.keys(groupedData[hotel]).map((email) => (
            <div key={email} className="email-section">
              <h4>User: {email}</h4>
               <div className="scrollable-table">
              <table className="review-table">
                <thead>
                  <tr>
                    <th>QR Data</th>
                    <th>Rating</th>
                    <th>Hotel Issues</th>
                    <th>Maintenance Issues</th>
                    <th>User IP</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {groupedData[hotel][email].map((review) => (
                    <tr key={review.id}>
                      <td>{review.qrData || "N/A"}</td>
                      <td>{review.rating}/5</td>
                      <td>{review.issueHotel}</td>
                      <td>{review.issueMaintenance}</td>
                      <td>{review.userIp || "Unknown"}</td>
                      <td>
                        {review.createdAt?.toDate
                          ? review.createdAt.toDate().toLocaleString()
                          : "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default History;
